import { Component, OnInit, NgModule, Output, EventEmitter, Input, ElementRef, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, FormBuilder, Validators, FormArray, FormGroup } from '@angular/forms';

import { NgSelectModule, NgOption } from '@ng-select/ng-select';

import { ActivatedRoute, Router } from '@angular/router';
import { RestService } from '../../../../shared/rest.service';
import { UbicacionesService } from '../../service/ubicaciones.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Observable } from 'rxjs/Observable';
import { CustomValidator } from '../../../../shared/customValidators';
import { UserService } from '../../../../pages/com.usblick.common/auth/user.service';
import { ItineraryService } from '../../../../shared/itinerary.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'usb-cruiser',
  templateUrl: './cruiser.component.html',
  styleUrls: ['./cruiser.component.scss']
})
export class CruiserComponent implements OnInit, OnDestroy {

  @Output() origin = new EventEmitter<any>();
  @Output() modal = new EventEmitter<string>();
  @Input() _close: boolean;

  @ViewChild("destination") myInputField: ElementRef;

  _form: FormGroup;
  minDate: Date;
  dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  _maxPersons: any; // : [0,1,2,3,4,5];
  _findData: boolean;
  isCollapsed = false;
  selectedDestiny: any;
  _longDestination: string;
  destiny: any;
  passengers: string;


  months = [
    { id: 1, name: 'Jan' }, { id: 2, name: 'Feb' }, { id: 3, name: 'Mar' }, { id: 4, name: 'Apr' }, { id: 5, name: 'May' },
    { id: 6, name: 'Jun' }, { id: 7, name: 'Jul' }, { id: 8, name: 'Aug' }, { id: 9, name: 'Sep' }, { id: 10, name: 'Oct' },
    { id: 11, name: 'Nov' }, { id: 12, name: 'Dec' }];

  selectedMonthsId: any;

  duration = [
    { id: 1, name: 'All' }, { id: 2, name: '1 - 4 Nigths' }, { id: 3, name: '5 - 9 Nigths' }, { id: 4, name: '10 - 14 Nigths' },
    { id: 5, name: '15 + Nigths' }];

  selectedDurationsId: any;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private fb: FormBuilder,
    private _routeActive: ActivatedRoute,
    private _router: Router,
    private _restService: RestService,
    private ubicacionesService: UbicacionesService,
    public userService: UserService,
    private cdr: ChangeDetectorRef,
    private _itineraryService: ItineraryService
  ) {
    this._maxPersons = Array.from(Array(11).keys());
    this.minDate = new Date();
    this.dpConfig.containerClass = 'theme-red';
  }
  ngOnInit() {
    this.passengers = "Passengers";
    this._findData = false;
    this._form = this.fb.group({
      destination: ['', Validators.compose([Validators.required, CustomValidator.countryValidator])],
      months: ['', Validators.required],
      durations: ['', Validators.required],
      qtyAdults: [0, [Validators.required, Validators.min(1)]],
      qtyChilds: [0, Validators.required],
      childsage: this.fb.array([]),
    });

    this._itineraryService.itinerary$.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
        this.myInputField.nativeElement.focus();
    }, 500);
  }

  _onSubmit(form: FormGroup, event?: Event, dummy?: Object) {
    if ((this.selectedDestiny !== undefined) && (this.selectedDestiny !== null)) {
    if (event) {
      event.preventDefault();
    }


    this._emitOrigin('CRUISES');
    this._router.navigate(['/results']);
  } else {
    this._form.get('destination').setErrors({ invalidDestination: true });
}
  }

  _emitOrigin(origin: any) {
    this.origin.emit(origin);
  }

  _addChild() {
    setTimeout(() => {
      const ages: any = this._form.get('childsage') as FormArray;
      const qty: number = +this._form.value['qtyChilds'];
      if (qty > ages.length) {
        for (let i = ages.length; i < qty; i++) {
          ages.push(this.fb.group({
            id: [i],
            age: [0, Validators.compose([Validators.required, Validators.min(0), Validators.max(17)])],
          }));
        }
      } else {
        for (let i = ages.length - 1; i >= qty; i--) {
          ages.removeAt(i);
        }
      }
    }, 10);
  }

  formArray(form: FormGroup, key: string) { return (<FormArray>form.get(key)).controls; }

  /***********************************************Auto Complete********************************************/
  _myListFormatter(data: any): string {
    return `${data['cityName']} (${data['cityIataCode']})`;
  }
  _myCallback(data: any): string {
    this._longDestination = this.destiny['cityName'];
    this.selectedDestiny = this.destiny['cityIataCode'];
    console.log('a enviar', this.destiny['cityIataCode']);
    console.log('long', this._longDestination);
    return `${data['cityName']} (${data['cityIataCode']})`;
  }

  observableSource = (keyword: any): Observable<any[]> => {
    return this.ubicacionesService.getCitys(keyword);
  }
  /***********************************************Auto Complete********************************************/

  _over() {
    this.modal.emit('false');
  }

  clickOutside(event: any) {
    this.setPassanger();
  }


  _openModal() {
    console.log(this._longDestination)
    this.isCollapsed = true;
    this._close = false;
    setTimeout(() => {
      this.modal.emit('true');
    }, 100);
  }

  _confirm() {
    this.isCollapsed = false;
    console.log(this._form.value['room'][0]['qtyAdults']);
  }

  setPassanger() {
    let adults = this._form.value['qtyAdults'];
    let childs = this._form.value['qtyChilds'];
    let noSelected = (parseInt(adults) === 0 && parseInt(childs) === 0);
    adults = adults != undefined ? adults + " Adults " : null;
    childs = childs != undefined ? " - " + childs + " Childs " : null;

    this.passengers = noSelected ? "Rooms and passengers" : adults + childs;
  }
}
